import React from "react";

import styles from "./TwoLineGridCell.module.scss";

interface Props {
  firstLineData?: React.ReactNode;
  secondLineData?: React.ReactNode;
}

const TwoLineGridCell = (props: Props) => {
  const { firstLineData, secondLineData } = props;

  return (
    <>
      <div className={styles.firstLine}>{firstLineData}</div>
      <div className={styles.secondLine}>{secondLineData}</div>
    </>
  );
};

export default TwoLineGridCell;
